import Api from '@/vuex/api'
import {
  LOAD_ACCOUNT,
  OPEN_MODAL,
  AGREE_CONTRACTOR_TOE,
  REVIEW_CUSTOMER
} from '@/vuex/types'

const api = new Api()
const state = {
  account: {
    uuid: '',
    AccountType: {}
  }
}

const mutations = {
  [LOAD_ACCOUNT] (state, account) {
    state.account = account
  }
}

const actions = {
  async [LOAD_ACCOUNT] (context, accountUuid) {
    let { account } = await api.getUser(accountUuid)
    context.commit(LOAD_ACCOUNT, { account: { ...account } })
  },
  [AGREE_CONTRACTOR_TOE] (context, contractorUuid) {
    let agreeTOEModal = {
      permalink: 'agreeContractorTOE',
      options: {
        strictOpen: true,
        title: 'Agreement',
        actionLabel: 'Agree'
      },
      params: {
        contractorUuid
      }
    }
    context.dispatch(OPEN_MODAL, agreeTOEModal)
  },
  [REVIEW_CUSTOMER] (context, customerUuid) {
    let reviewCustomerModal = {
      permalink: 'reviewCustomer',
      options: {
        title: 'Review Customer',
        actionLabel: 'Submit'
      },
      params: {
        customerUuid
      }
    }
    context.dispatch(OPEN_MODAL, reviewCustomerModal)
  }

}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/account.js